import { login } from 'services';
import router from 'umi/router';
export default {
  namespace: 'login',
  state: {},
  effects: {
    *login({ payload }, { call, put }) {
      const response = yield call(login, payload);
      const { useBut, useUrl } = payload;
      // 去使用按钮判断
      if (useBut) {
        localStorage.setItem(
          'useBut',
          JSON.stringify({
            value: useBut,
            expire: new Date(),
          }),
        );
        useUrl &&
          localStorage.setItem(
            'useUrl',
            JSON.stringify({
              value: useUrl,
              expire: new Date(),
            }),
          );
      }
      if (response.data.state === '11') {
        const { isLogin, token, dragoncode, agentId, qrcode } = response.data.data;
        if (isLogin) {
          localStorage.setItem('dragoncode', dragoncode);
          // 20230509 工行要求，在网点列表页也展示首页按钮，而之前首页需要龙腾卡和qrcode两个字段
          qrcode && localStorage.setItem('qrcode', qrcode);
          localStorage.setItem('token', `Bearer ${token}`);
          agentId && localStorage.setItem('agentId', agentId);
          router.replace({
            pathname: payload.redirectUrl,
            query: payload,
          });
        }
      }
    },
  },
  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
